import React from "react";

import { SCROLLING_CONTAINER_ID } from "config/common";

import HeaderContainer from "app-shell/HeaderContainer/HeaderContainer";

import "./Layout.scss";
import { Footer, getFooterLinks } from "component-library";

interface ILayoutProps {}

export class Layout extends React.Component<
  React.PropsWithChildren<ILayoutProps>
> {
  private menuContainerRef = React.createRef<HTMLDivElement>();
  private popupContainerRef = React.createRef<HTMLDivElement>();

  public render() {
    const footer = getFooterLinks();

    return (
      <div className="a-layout">
        <div className="a-layout__header">
          <HeaderContainer
            menuContainer={this.menuContainerRef}
            popupContainer={this.popupContainerRef}
          />
        </div>
        <div className="a-layout__body">
          <div
            ref={this.menuContainerRef}
            className="a-layout__menu-container"
          />
          <div
            ref={this.popupContainerRef}
            className="a-layout__localization-popup-container"
          />
          <div
            className="a-layout__content-container"
            id={SCROLLING_CONTAINER_ID}
          >
            {this.props.children}
            <Footer
              navigationLinks={footer.navigationLinks}
              texts={footer.texts}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Layout;
